package org.example.project.game

object ScoringEngine {

    private const val CORRECT_ANSWER_POINTS = 20

    private const val HIT_POINTS = 50

    private const val SHIP_SUNK_POINTS = 100

    private const val WIN_POINTS = 250

    fun correctAnswerScore(
        currentScore: Int
    ): Int {

        return currentScore +
                CORRECT_ANSWER_POINTS
    }

    fun hitScore(
        currentScore: Int
    ): Int {

        return currentScore +
                HIT_POINTS
    }

    fun shipSunkScore(
        currentScore: Int
    ): Int {

        return currentScore +
                SHIP_SUNK_POINTS
    }

    fun winScore(
        currentScore: Int
    ): Int {

        return currentScore +
                WIN_POINTS
    }
}